/**
 * Approved compliance copy for the forward-facing public website (UAD-3739).
 *
 * Changing these strings changes every public-facing surface — the generic
 * marketing pages and every agent subsite. Treat edits here as a compliance
 * action, not a content tweak.
 *
 * Rendered by src/components/shared/ComplianceDisclaimer for standalone
 * placements, and imported as raw strings where the copy is merged into an
 * existing consent paragraph.
 */

// Shown wherever a visitor is about to submit data or book time.
export const DISCLAIMER_SHORT =
  'Insurance services are provided by Richard Banville LLC and appropriately ' +
  'licensed insurance producers. USA Benefits Group provides marketing and ' +
  'lead-generation services.'

// Long disclaimer, Version A — names the agent. Active.
export const DISCLAIMER_LONG_WITH_AGENT =
  'USA Benefits Group provides marketing and lead-generation services. ' +
  'Insurance products and services are offered through Richard Banville LLC ' +
  'and its appropriately licensed insurance producers. Richard Banville LLC ' +
  'is a licensed insurance agency. {agentName} is a licensed insurance ' +
  'producer. Product availability varies by state.'

// Long disclaimer, Version B — no agent name. Used when the toggle below is
// off, and always on generic pages where there is no agent.
export const DISCLAIMER_LONG_NO_AGENT =
  'USA Benefits Group provides marketing and lead-generation services. ' +
  'Insurance products and services are offered through Richard Banville LLC ' +
  'and its appropriately licensed insurance producers. Richard Banville LLC ' +
  'is a licensed insurance agency. Product availability varies by state.'

// Toggle: true = Version A (with agent name), false = Version B everywhere.
export const LONG_DISCLAIMER_INCLUDE_AGENT_NAME = true

/**
 * Resolve the long disclaimer for a given agent.
 *
 * Falls back to Version B when the toggle is off, and — importantly — also
 * when no usable name was passed. Subsite data loads asynchronously, so
 * without that guard the first paint renders " is a licensed insurance
 * producer." Callers on generic pages simply pass nothing.
 */
export const getLongDisclaimer = agentName => {
  if (!LONG_DISCLAIMER_INCLUDE_AGENT_NAME) return DISCLAIMER_LONG_NO_AGENT

  const name = `${agentName || ''}`.trim()
  if (!name) return DISCLAIMER_LONG_NO_AGENT

  return DISCLAIMER_LONG_WITH_AGENT.replace('{agentName}', name)
}
